<template>
  <v-container>
    <!-- Diálogo de éxito -->
    <v-dialog v-model="dialogSuccess" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">Cita anulada exitosamente</p>
          <p class="text-center">Gracias por avisarnos. Esperamos verte pronto.</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn to="/" color="primary" class="container">Volver al inicio</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de error -->
    <v-dialog v-model="dialogError" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">Error</p>
          <p class="text-center">{{ errorMessage }}</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn to="/" color="primary" class="container">Volver al inicio</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Estado de carga -->
    <div v-if="loading" class="text-center mt-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <p class="font-weight-light mt-4">Cargando información de la cita...</p>
    </div>

    <!-- Mostrar datos de la hora para anular -->
    <div v-else-if="hour && !dialogSuccess && !dialogError">
      <div class="text-center mb-4">
        <h2 class="error--text">Anular tu cita</h2>
        <p class="grey--text">Por favor revisa los datos antes de anular</p>
      </div>

      <div class="d-flex justify-center mb-4">
        <professional-avatar
          v-bind:id-professional="(hour.professional || {}).id"
          v-bind:size="80"
        ></professional-avatar>
      </div>
      <p class="text-center primary--text title">{{(hour.professional || {}).fullName}}</p>

      <v-divider></v-divider>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Especialidad</v-list-item-title>
            <v-list-item-subtitle>{{(hour.specialty || {}).name}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Fecha</v-list-item-title>
            <v-list-item-subtitle>{{hour.date}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Hora</v-list-item-title>
            <v-list-item-subtitle>{{hour.start}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="my-4"></v-divider>

      <!-- Advertencia -->
      <v-alert type="warning" outlined class="mb-4">
        <strong>Atención:</strong> Esta acción no se puede deshacer.
        Si anulas tu cita, la hora quedará disponible para otros pacientes.
      </v-alert>

      <!-- Botones de acción -->
      <div class="d-flex justify-center">
        <v-btn
          color="grey"
          outlined
          large
          class="mr-4"
          to="/"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="error"
          large
          :loading="canceling"
          :disabled="canceling"
          @click="executeCancel"
        >
          <v-icon left>mdi-close</v-icon>
          Sí, anular mi cita
        </v-btn>
      </div>

      <p class="text-center grey--text mt-4 caption">
        Si necesitas reagendar, puedes buscar una nueva hora después de anular.
      </p>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    hour: {},
    loading: true,
    canceling: false,
    dialogSuccess: false,
    dialogError: false,
    errorMessage: ""
  }),
  methods: {
    // Obtener datos de la hora sin ejecutar anulación
    async getHourData() {
      try {
        if (!this.$route.params.token) {
          throw new Error("Falta token en URL");
        }
        // Llamar al endpoint sin execute para solo obtener datos
        let { data } = await this.$http.post("cancelhourbytoken", {
          actionToken: this.$route.params.token
        });
        this.hour = data.hour || data;
        this.loading = false;
      } catch (err) {
        this.errorMessage = (err.response && err.response.data && err.response.data.msg) || err.message || "Error al cargar la información";
        this.dialogError = true;
        this.loading = false;
      }
    },

    // Ejecutar la anulación
    async executeCancel() {
      try {
        this.canceling = true;
        let { data } = await this.$http.post("cancelhourbytoken", {
          actionToken: this.$route.params.token,
          execute: true
        });
        this.hour = data.hour || data;
        this.dialogSuccess = true;
      } catch (err) {
        this.errorMessage = (err.response && err.response.data && err.response.data.msg) || err.message || "Error al anular la cita";
        this.dialogError = true;
      } finally {
        this.canceling = false;
      }
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == "Anular cita") {
        this.hour = {};
        this.loading = true;
        this.dialogSuccess = false;
        this.dialogError = false;
        this.errorMessage = "";
        this.getHourData();
      }
      if (from.name == "Anular cita") {
        this.hour = {};
      }
    }
  },
  mounted() {
    this.getHourData();
  }
};
</script>

<style>
</style>
